import axiosInstance from '@/api/axiosInstance';
export default { namespaced: true, state: { associates: [], circles: [] }, mutations: { set(state, { key, data }) { state[key] = data; } }, actions: {
  async load({ commit }) {
    const [a, c] = await Promise.all([axiosInstance.get('/associates/list?size=1000&page=1&statusFilter=activos'), axiosInstance.get('/circles/list?size=200&page=1')]);
    commit('set', { key: 'associates', data: a.data.data.associates.list || [] }); commit('set', { key: 'circles', data: c.data.data.circles.list || [] });
  },
} };
